import {AutoMap} from '@automapper/classes';

export abstract class UserAuthenticationBaseRequestDto {

}

export class UserAuthenticationBaseResponseDto {
  @AutoMap()
  public firstName!: string

  @AutoMap()
  public lastName!: string | null

  @AutoMap()
  public email!: string

  @AutoMap()
  public accessToken!: string

  @AutoMap()
  public refreshToken!: string
}
